import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CTA.module.css';

const CTA: React.FC = () => {
  return (
    <section className={styles.outerSection}>
      <div className={styles.card}>
        <h2 className={styles.title}>
          B2B is not rocket science but
        </h2>
        <p className={styles.text}>
          Le commerce B2B est en pleine révolution. En Europe, on parle d'un marché
          colossal qui pèse environ{' '}
          <span className={styles.highlight}>5 000 milliards d'euros</span>. Ça
          représente <span className={styles.highlight}>75%</span> des échanges
          commerciaux, et ce n'est que le début. De plus en plus d'entreprises
          adoptent des solutions digitales pour simplifier les process et accélérer
          les transactions. Mais, y'a plus le temps.
        </p>
        <p className={styles.text}>
          À l'échelle mondiale, le marché du B2B en ligne est en feu. Il devrait
          atteindre{' '}
          <span className={styles.highlight}>
            25 650 milliards de dollars d'ici 2028
          </span>{' '}
          avec une croissance impressionnante de{' '}
          <span className={styles.highlight}>18,7% par an</span>. D'ailleurs,
          environ <span className={styles.highlight}>80% des acheteurs B2B</span>{' '}
          préfèrent déjà gérer leurs commandes en ligne plutôt qu'à l'ancienne.
        </p>
        <p className={styles.text}>
          La suite ? L'IA, le big data et l'automatisation vont encore plus booster
          le secteur en rendant tout plus simple et plus fluide. Bref, le digital
          n'est plus une option, c'est un passage obligé pour rester compétitif dans
          le B2B aujourd'hui !
        </p>
        <Link to="/inscriptions" className={styles.button}>
          S'INSCRIRE À B2B
        </Link>
      </div>
    </section>
  );
};

export default CTA;
